import { memo } from 'react';

import { ReadMore } from '@atom/read-more/read-more';

export const ConsumerLink = memo(() => (
  <ReadMore title='Read docs' to='https://docs.universalapi.io/reference/introduction-2' />
));
